import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { UserData } from '../models';

class UserService {
  /**
   * Get complete user data from Firestore
   */
  async getUser(userId: string): Promise<UserData | null> {
    try {
      const docRef = doc(db, 'users', userId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        return {
          firstName: data.firstName || '',
          isAdmin: data.isAdmin || false,
          defaultBibleVersion: data.defaultBibleVersion || 'ESV',
          defaultFontSize: data.defaultFontSize || 'md',
          notifications: data.notifications,
          completedDays: data.completedDays || {},
        };
      }
      return null;
    } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
    }
  }

  /**
   * Create or update user data using setDoc with merge
   */
  async createOrUpdateUser(
    userId: string,
    userData: Partial<UserData>
  ): Promise<void> {
    try {
      const docRef = doc(db, 'users', userId);
      await setDoc(docRef, userData, { merge: true });
    } catch (error) {
      console.error('Error creating/updating user:', error);
      throw error;
    }
  }
}

export const userService = new UserService();
